import { render, staticRenderFns } from "./ApprovedOriginalDocuments.vue?vue&type=template&id=65aeec7f&scoped=true"
import script from "./ApprovedOriginalDocuments.vue?vue&type=script&lang=js"
export * from "./ApprovedOriginalDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aeec7f",
  null
  
)

export default component.exports